import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { Loader2, ArrowLeft, ShieldCheck } from "lucide-react";
import { api, formatError } from "@/lib/api";

export default function AdminResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("Kata sandi minimal 6 karakter.");
    if (password !== confirm) return toast.error("Konfirmasi kata sandi tidak cocok.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Kata sandi berhasil diubah. Silakan masuk.");
      navigate("/admin/login");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-xl bg-navy-soft border border-white/10 px-4 py-3 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-cyan/60 focus:ring-2 focus:ring-cyan/20 transition-all";

  return (
    <div className="min-h-screen grain relative bg-navy text-white grid place-items-center px-4">
      <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[40rem] h-[40rem] radial-glow z-0" />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 w-full max-w-md rounded-3xl border border-white/10 bg-navy-card/70 backdrop-blur-xl p-8"
      >
        <Link to="/admin/login" className="inline-flex items-center gap-1.5 text-xs text-slate-400 hover:text-cyan transition mb-6">
          <ArrowLeft className="w-3.5 h-3.5" /> Kembali ke login
        </Link>

        <h1 className="font-heading font-bold text-2xl flex items-center gap-2">
          <ShieldCheck className="w-5 h-5 text-gold" /> Atur Ulang Kata Sandi
        </h1>

        {!token ? (
          <p className="text-sm text-red-400 mt-3" data-testid="reset-no-token">Tautan tidak valid atau tidak lengkap. Silakan minta tautan baru dari halaman "Lupa kata sandi".</p>
        ) : (
          <form onSubmit={submit} className="mt-7 space-y-4" data-testid="reset-form">
            <div>
              <label className="text-sm text-slate-300 font-medium">Kata Sandi Baru</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={`mt-2 ${inputCls}`} placeholder="••••••••" required data-testid="reset-password" />
            </div>
            <div>
              <label className="text-sm text-slate-300 font-medium">Konfirmasi Kata Sandi</label>
              <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={`mt-2 ${inputCls}`} placeholder="••••••••" required data-testid="reset-confirm" />
            </div>
            <button type="submit" disabled={loading} data-testid="reset-submit" className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-gold px-6 py-3.5 font-body font-bold text-navy hover:shadow-[0_0_30px_rgba(212,175,55,0.4)] disabled:opacity-60 transition-all duration-300">
              {loading && <Loader2 className="w-5 h-5 animate-spin" />} Simpan Kata Sandi
            </button>
          </form>
        )}
      </motion.div>
    </div>
  );
}
